import { Divider } from "@mui/material";
import { useState } from "react";

import AccountItem from "./AccountItem";
import AccountMenu from "./Menu/AccountMenu";

// ----------------------------------------------------------------------

export default function AccountPopover() {
	const [open, setOpen] = useState<HTMLElement | null>(null);

	const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
		setOpen(event.currentTarget);
	};

	const handleClose = () => {
		setOpen(null);
	};

	return (
		<>
			<Divider sx={{ borderStyle: "dashed" }} />
			<AccountItem onOpen={handleOpen} />
			<AccountMenu onClose={handleClose} isOpen={open} />
		</>
	);
}
